/**
 * "2026-06-18" → "18/06"
 */
export const formatShortDate = (iso) => {
    if (!iso || typeof iso !== 'string') return '—';
    const parts = iso.split('-');
    if (parts.length !== 3) return iso;
    const [, month, day] = parts;
    return `${day}/${month}`;
};

/**
 * Affiche "J-0 11h", "J-1 14h", etc.
 */
export const formatTiming = (timingDay, timingHour) => {
    const dayPart = `J-${timingDay ?? 0}`;
    if (timingHour === null || timingHour === undefined || timingHour === '') {
        return dayPart;
    }
    return `${dayPart} ${timingHour}h`;
};

/**
 * Affiche la fenêtre d'activité : "18/06 → 25/06"
 */
export const formatActivityWindow = (window) => {
    if (!window?.start || !window?.end) return '—';
    return `${formatShortDate(window.start)} → ${formatShortDate(window.end)}`;
};

export const formatReferenceDate = (iso) => {
    if (!iso) return '—';
    const parts = iso.split('-');
    if (parts.length !== 3) return iso;
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
};

export const formatGeneratedAt = (iso) => {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    } catch {
        return iso;
    }
};

export const todayIsoDate = () => new Date().toISOString().split('T')[0];

/**
 * Ajoute un décalage en jours à une date ISO (YYYY-MM-DD).
 */
export const addDaysToIsoDate = (isoDate, days) => {
    if (!isoDate || days === null || days === undefined) return isoDate || null;
    const date = new Date(`${isoDate}T12:00:00`);
    if (Number.isNaN(date.getTime())) return null;
    date.setDate(date.getDate() + Number(days));
    return date.toISOString().split('T')[0];
};

const parisNowParts = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (type) => parts.find((p) => p.type === type)?.value;
    return { date: `${get('year')}-${get('month')}-${get('day')}`, hour: Number(get('hour')) };
};

/**
 * Le check forecast est prévu à J-forecast_timing_day de trip_day, à forecast_timing_hour (heure de Paris).
 * Retourne true si ce créneau est dépassé.
 */
export const isForecastCheckOverdue = (row) => {
    const tripDay = row?.trip_day || row?.date_to_check;
    if (!tripDay) return false;
    const checkDate = addDaysToIsoDate(tripDay, -(Number(row.forecast_timing_day) || 0));
    if (!checkDate) return false;
    const now = parisNowParts();
    if (now.date !== checkDate) return now.date > checkDate;
    const hour = row.forecast_timing_hour;
    if (hour === null || hour === undefined || hour === '') return false;
    return now.hour > Number(hour);
};

/**
 * Fin effective = new_trip_end_date + effective_end_date (jours).
 */
export const computeEffectiveTripEndDate = (newTripEndDate, effectiveEndDate) => {
    if (!newTripEndDate) return null;
    if (effectiveEndDate === null || effectiveEndDate === undefined || effectiveEndDate === 0) {
        return newTripEndDate;
    }
    return addDaysToIsoDate(newTripEndDate, effectiveEndDate);
};

export const formatEffectiveEndOffset = (offset) => {
    if (offset === null || offset === undefined || offset === 0) return null;
    return offset > 0 ? `+${offset}j` : `${offset}j`;
};
